import { createServerOnlyFn } from "@tanstack/react-start";
import { handleSmsOptIn } from "./sms-opt-in.server";

export const smsOptInApiRoute = {
    server: {
        handlers: {
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                handleSmsOptIn(request),
            ),
        },
    },
};
